var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import './SeriesMAL.scss';
import SeriesPoster from '../KodanshaUIKit/SeriesPoster/SeriesPoster';
import KodanshaUnderlinedText from '../KodanshaUIKit/KodanshaUnderlinedText/KodanshaUnderlinedText';
import { SeriesDataMAL } from './SeriesDataMAL';
import { useAtom } from 'jotai';
import { LoginStatusAtom } from '../../store/AccountStore';
import { LoginOverlayVisible } from '../../store/OverlayStore';
import { Link, useHistory } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper';
import { useWindowSize } from '../Hooks/useWindowSize';
import 'swiper/css';
import 'swiper/css/virtual';
export var SeriesItem = function (_a) {
    var data = _a.data;
    var history = useHistory();
    var _b = __read(useAtom(LoginStatusAtom), 1), loginStatus = _b[0];
    var _c = __read(useAtom(LoginOverlayVisible), 2), setLoginOverlay = _c[1];
    var onButtonCLicked = function (e) {
        if (e.currentTarget.textContent === 'Sign up to read') {
            setLoginOverlay(true);
            return;
        }
    };
    return _jsxs("div", { className: 'series-item-wrapper', children: [_jsx(Link, { target: '_blank', to: '/series/' + data.readableUrl, className: 'series-item-link', children: _jsx(SeriesPoster, { ratio: 120, isGray: true, color: data.color, src: data.image }) }), _jsxs("div", { className: 'series-item-info-wrapper', children: [_jsx("h5", { className: 'series-name', children: data.name }), data.reader !== -1 ? _jsx(Link, { target: '_blank', to: {
                            pathname: '/reader/' + data.reader.toString(),
                            state: { returnPath: history.location.pathname },
                        }, children: _jsx(KodanshaUnderlinedText, { text: 'Read chapter 1' }) }) : null] })] });
};
var SeriesMAL = function () {
    var ref = useRef();
    var width = useWindowSize().width;
    var SwiperRef = useRef();
    return (_jsxs("div", { className: 'series-ax-container', children: [_jsx("h1", { className: 'header-one', children: "Attack on Titan Spinoffs" }), _jsx("h2", { className: 'header-two', children: "Go beyond the main series with spinoffs, parodies, and more" }), _jsx("div", { className: 'series-mal-grid-wrapper', children: _jsx(Swiper, { ref: ref, spaceBetween: 15, slidesPerView: 2, slidesPerGroup: 2, touchEventsTarget: 'container', freeMode: width < 1278, modules: [FreeMode], longSwipesRatio: 0.01, onSwiper: function (swiper) {
                        SwiperRef.current = swiper;
                    }, navigation: {
                        prevEl: '.prev',
                        nextEl: '.next',
                    }, onResize: function (swiper) {
                        swiper.params.freeMode = __assign(__assign({}, swiper.params.freeMode), { enabled: width < 1278 });
                        // (swiper.params.freeMode as FreeModeOptions).enabled = width < 768;
                        // ref.current && setWheelContainerSize(ref.current.getBoundingClientRect().height);
                        // calculateWheelItemSize();
                        swiper.update();
                    }, onEnded: function () {
                        // setPage(999);
                    }, onSlideChange: function () {
                        // setPage(SwiperRef.current.realIndex);
                    }, breakpoints: {
                        576: {
                            slidesPerView: 2.2,
                            slidesPerGroup: 2,
                        },
                        768: {
                            slidesPerView: 3.2,
                            slidesPerGroup: 3,
                        },
                        1278: {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                        },
                    }, children: SeriesDataMAL.map(function (data, index) {
                        return _jsx(SwiperSlide, { children: _jsx(SeriesItem, { data: data }) }, index);
                    }) }) })] }));
};
export default SeriesMAL;
